import LoginAuth from './LoginAuth';
import PagePerso from './PagePerso';
import SelectPerso from './parts/SelectPerso';
import { useAuth0 } from "@auth0/auth0-react";
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ip = process.env.REACT_APP_IP;

const FichePerso = () => {
  const { user, isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();
  const [login, setLogin] = useState(JSON.parse(sessionStorage.getItem("login")) || false);
  const [persos, setPersos] = useState(JSON.parse(sessionStorage.getItem("persos")) || []);
  const [joueur, setJoueur] = useState(JSON.parse(sessionStorage.getItem("joueur")) || null);
  const [errorMessage, setErrorMessage] = useState('');
  const [selectedPerso, setSelectedPerso] = useState(() => {
    const savedPerso = sessionStorage.getItem("selectedPerso");
    return savedPerso ? JSON.parse(savedPerso) : null;
  });
  const [token, setToken] = useState(sessionStorage.getItem("token") || null);

  const handleSubmit = async () => {
    try {
      const token = await getAccessTokenSilently({
        audience: process.env.REACT_APP_AUDIENCE,
        scope: 'read:user'
      });
      const email = user.email;
      const response = await axios.post(
        `${ip}/user`,
        { email },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setPersos(response.data.joueur.personnages);
      setJoueur(response.data.joueur.login);
      setLogin(true);
      setErrorMessage('');
      setToken(token); // Store the token
    } catch (error) {
      console.error('Error:', error);
      setErrorMessage('Invalid login or password');
    }
  };

  useEffect(() => {
    if (isAuthenticated && !isLoading && !login) {
      handleSubmit();
    }
  }, [isAuthenticated, isLoading, login]);

  useEffect(() => {
    sessionStorage.setItem("login", JSON.stringify(login));
    sessionStorage.setItem("persos", JSON.stringify(persos));
    sessionStorage.setItem("joueur", JSON.stringify(joueur));
  }, [login, persos, joueur]);

  useEffect(() => {
    sessionStorage.setItem("selectedPerso", JSON.stringify(selectedPerso));
  }, [selectedPerso]);

  useEffect(() => {
    if (token) {
      sessionStorage.setItem("token", token);
    }
  }, [token]);

  if (isLoading) {
    return <div>Chargement</div>;
  }

  if (!isAuthenticated ) {
    return <LoginAuth />;
  }

  if (!selectedPerso) {
    return (
      <SelectPerso
        personnages={persos}
        setSelectedPerso={setSelectedPerso}
        joueur={joueur}
        token={token} 
        fetchPerso={handleSubmit}
      />
    );
  }

  return (
    <PagePerso
      idJoueur={joueur}
      perso={selectedPerso}
      setSelectedPerso={setSelectedPerso}
      token={token} 
    />
  );
};

export default FichePerso;
